

import Vue from 'vue';
import Component from "vue-class-component";

import {IOnOffHandlers} from "bonomo/dist";
import {Prop} from "vue-property-decorator";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import ImageUploader from "@/components/shared/ImageUploader.vue";

@Component({
  components: {ImageUploader},
})
export default class LMUploadLogoDialog extends Vue {

  @Prop()
  protected locker!: ILocker;

  @Prop()
  protected loading!: boolean;

  protected showing: boolean = false;

  protected subscribes: IOnOffHandlers = {};

  protected get endpoint(): string {
    return `lockers/${this.locker.id}/logo`
  }

  public created() {
    this.subscribes = this.$ons({
      // NOTE not managing login OK/KO here as it would cause more problems than solve
      'backend.call.OK.imageUploaded': this.onOK,
      'backend.call.KO.imageUploaded': this.onKO,
    });
  }

  public beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onOK() {
    this.$emit('changed');
    this.$uiBus.emit('success', this.$t('lockers.locker.logoImage.toastOK'))
    this.showing = false;
  }

  private onKO() {
    // this.loading = false;
    // this.$uiBus.emit('alert', 'KO');
  }

}

